package io.horion.cv.api.datasource.motivation

import kotlinx.serialization.Serializable

@Serializable
data class MotivationConfig(
    val primaryColor: String = "#2C3E50",          // Couleur principale (ex: titres, bordures)
    val secondaryColor: String = "#3498DB",        // Couleur secondaire (accents, sous-titres)
    val backgroundColor: String = "#FFFFFF",       // Fond du document
    val textColor: String = "#000000",             // Couleur principale du texte
    val subtitleColor: String = "#7F8C8D",         // Couleur des sous-titres
    val accentColor: String = "#E67E22",           // Accent visuel (barres, séparateurs)
    val fontFamily: String = "Helvetica",          // Police d’écriture principale
    val fontSizeTitle: Float? = 14f,                // Taille des titres
    val fontSizeSubtitle: Float? = 11f,             // Taille des sous-titres
    val fontSizeText: Float? = 9.5f,                // Taille du texte
)
